class ProductViewer extends HTMLElement {
  constructor() {
    super();
    this.colorButtons = this.querySelectorAll('.product-viewer__color-btn');
    this.colorNames = this.querySelectorAll('.product-viewer__color-name');
    this.variantImages = this.querySelectorAll('.product-viewer__variant-image');
    this.editionButtons = this.querySelectorAll('.product-viewer__edition-btn');

    this.colorMemory = new Map();
    const initialActiveColor = this.querySelector('.product-viewer__color-btn.active');
    if (initialActiveColor) {
      this.colorMemory.set(
        initialActiveColor.getAttribute('data-edition'),
        initialActiveColor.getAttribute('data-block-id')
      );
    }

    this.event();
  }
  
  editionButtonClickHandler () {
    this.editionButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const currentActiveColor = this.querySelector('.product-viewer__color-btn.active');
        if (currentActiveColor) {
          this.colorMemory.set(
            currentActiveColor.getAttribute('data-edition'),
            currentActiveColor.getAttribute('data-block-id')
          );
        }

        const edition = e.currentTarget.getAttribute('data-edition');
        this.editionButtons.forEach(btn => {
          btn.classList.toggle('active', btn.getAttribute('data-edition') === edition);
        });
        
        this.colorButtons.forEach(btn => btn.classList.remove('show-color'));
        this.colorButtons.forEach(btn => {
          if(btn.getAttribute('data-edition') === edition) {
            btn.classList.add('show-color');
          }
        });
        
        this.colorButtons.forEach(btn => btn.classList.remove('active'));

        const rememberedBlockId = this.colorMemory.get(edition);
        let targetColorNode = rememberedBlockId
          ? this.querySelector(`.product-viewer__color-btn.show-color[data-block-id="${rememberedBlockId}"]`)
          : null;
        if (!targetColorNode) {
          targetColorNode = this.querySelectorAll('.product-viewer__color-btn.show-color')[0];
        }

        targetColorNode.classList.add('active');
        this.changeCurrentImageViewer(targetColorNode.getAttribute('data-block-id'));
        this.updateColorName(targetColorNode.getAttribute('data-color-name'));
      });
    });
  }
  
  colorButtonClickHandler () {
    this.colorButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const btn = e.currentTarget;
        this.colorButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        this.colorMemory.set(btn.getAttribute('data-edition'), btn.getAttribute('data-block-id'));
        this.changeCurrentImageViewer(btn.getAttribute('data-block-id'));
        this.updateColorName(btn.getAttribute('data-color-name'));
      });
    });
  }
  
  updateColorName (colorName) {
    document.querySelector("#color-name-content").textContent = colorName;
  }
  
  modalClickHandler () {
    const openModalBtns = this.querySelectorAll('.product-viewer__spec-btn');
    const modalOverlay = this.querySelector('.product-viewer__modal-overlay');
    const modal = this.querySelector('.product-viewer__modal');
    const closeModalBtn = this.querySelector('.product-viewer__modal-close');

    if (modalOverlay && modal) {
      openModalBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          modalOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      });

      closeModalBtn.addEventListener('click', closeModal);
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
          closeModal();
        }
      });

      function closeModal() {
        modalOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      // Modal Tabs
      const modalTabs = modal.querySelectorAll('.product-viewer__modal-tab');
      const modalContents = modal.querySelectorAll('.product-viewer__modal-content');

      modalTabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const targetTab = this.getAttribute('data-tab');
          
          modalTabs.forEach(t => t.classList.remove('active'));
          modalContents.forEach(c => c.classList.remove('active'));
          
          this.classList.add('active');
          document.getElementById(targetTab + '-content').classList.add('active');
        });
      });

      // Modal Edition Tabs


      // Spec Group Accordion
      const specGroups = modal.querySelectorAll('.product-viewer__spec-group-header');
      specGroups.forEach(header => {
        header.addEventListener('click', function() {
          const group = this.closest('.product-viewer__spec-group');
          group.classList.toggle('collapsed');
        });
      });
      
      // AR Modal
      const arModal = this.querySelector('.product-viewer__ar-modal');
      const arModalOverlay = this.querySelector('.product-viewer__ar-modal-overlay');
      const openArModalBtns = this.querySelector('.product-viewer__ar-btn');
      const closeArModalBtn = this.querySelector('.product-viewer__ar-modal-close');
      if (arModal && arModalOverlay) {
        openArModalBtns.addEventListener('click', function() {
          arModalOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
        });

        closeArModalBtn.addEventListener('click', closeArModal);
        arModalOverlay.addEventListener('click', function(e) {
          if (e.target === arModalOverlay) {
            closeArModal();
          }
        });
      }

      function closeArModal() {
        arModalOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && arModalOverlay && arModalOverlay.classList.contains('active')) {
          closeArModal();
        }
      });
    }
  }
  
  event () {
    this.editionButtonClickHandler();
    this.colorButtonClickHandler();
    this.modalClickHandler();
  }
  
  changeCurrentColorCursor (blockId) {
    const blockViewer = this.querySelector(`.product-viewer__image-item[data-block-id="${blockId}"]`);
    const colorButtons = this.querySelectorAll(`.product-viewer__color-btn`);
    colorButtons.forEach(colorButton => {
      colorButton.classList.remove('active');
    });
    blockViewer.classList.add('active');
  }
  
  changeCurrentImageViewer (blockId) {
    const blockViewer = this.querySelector(`.product-viewer__image-item[data-block-id="${blockId}"]`);
    const imageViewers = this.querySelectorAll(`.product-viewer__image-item`);
    
    // 在切换前，重置当前活跃的 360 视图到第一张图片
    const currentActiveViewer = this.querySelector('.product-viewer__image-item.active image-viewer-360');
    if (currentActiveViewer && typeof currentActiveViewer.resetToFirstImage === 'function') {
      currentActiveViewer.resetToFirstImage();
    }
    
    imageViewers.forEach(imageViewer => {
      imageViewer.classList.remove('active');
    });
    blockViewer.classList.add('active');
    blockViewer.querySelector('image-viewer-360').setAttribute('data-active', 'true');
  }
}

customElements.define('product-viewer', ProductViewer);

class ProductViewerModal extends HTMLElement {
  constructor() {
    super();
    this.event();
    
    this._data = {
      currentEdition: null
    };
    
    this.state = new Proxy(this._data, {
      set: (target, property, value) => {
        const oldValue = target[property];
        
        // 只在值改变时触发
        if (oldValue !== value) {
          target[property] = value;
          
          const method = `on${this.capitalize(property)}Change`;
          if (typeof this[method] === 'function') {
            this[method](value, oldValue);
          }
        }
        
        return true;
      }
    });
    
    Object.defineProperty(this, 'currentEdition', {
      get: () => this.state.currentEdition,
      set: (value) => { this.state.currentEdition = value; }
    });
  }
  
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  
  onCurrentEditionChange(newValue, oldValue) {
    this.updateGeometryImageUI(newValue);
    this.updateGeometryContentUI(newValue);
  }
  
  updateGeometryImageUI (newValue) {
    const geometryImages = this.querySelectorAll('.product-viewer__modal-geometry-thumbnail-item');
    geometryImages.forEach(image => {
      image.classList.remove('active');
    });
    const geometryImage = this.querySelector(`.product-viewer__modal-geometry-thumbnail-item[data-edition="${newValue}"]`);
    geometryImage.classList.add('active');
  }
  
  updateGeometryContentUI (newValue) {
    const geometryContents = this.querySelectorAll('.product-viewer__modal-geometry-content-item');
    geometryContents.forEach(content => {
      content.classList.remove('active');
    });
    const geometryContent = this.querySelector(`.product-viewer__modal-geometry-content-item[data-edition="${newValue}"]`);
    geometryContent.classList.add('active');
  }

  event () {
    this.editionControlButtonClickHandler();
  }

  editionControlButtonClickHandler () {
    const container = this;
    const modalEditionBtns = container.querySelectorAll('.product-viewer__modal-edition-btn');
    modalEditionBtns.forEach(button => {
      button.addEventListener('click', function() {
        modalEditionBtns.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        container.state.currentEdition = this.getAttribute('data-edition');
      });
    });
  }
}

customElements.define('product-viewer-modal', ProductViewerModal);

class ProductViewerCompare extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.totalSlides = 0;
    this.init();
  }
  
  init() {
    // Get elements
    this.desktopSlides = this.querySelectorAll('.product-viewer__compare-slide');
    this.mobileSlides = this.querySelectorAll('.product-viewer__compare-mobile-slide');
    this.indicators = this.querySelectorAll('.product-viewer__compare-mobile-indicator');
    this.totalSlides = this.desktopSlides.length;
    
    // Desktop navigation buttons
    this.prevBtn = this.querySelector('.product-viewer__compare-nav--prev');
    this.nextBtn = this.querySelector('.product-viewer__compare-nav--next');
    
    // Mobile navigation buttons
    this.prevBtnMobile = this.querySelector('.product-viewer__compare-mobile-nav-btn--prev');
    this.nextBtnMobile = this.querySelector('.product-viewer__compare-mobile-nav-btn--next');
    
    // Close buttons
    this.closeButtons = this.querySelectorAll('.product-viewer__compare-close');
    
    // Open button
    const parentViewer = this.closest('product-viewer');
    if (parentViewer) {
      this.openBtn = parentViewer.querySelector('.product-viewer__compare-btn');
    }
    
    this.bindEvents();
    this.updateNavButtons();
  }
  
  bindEvents() {
    // Open modal
    if (this.openBtn) {
      this.openBtn.addEventListener('click', () => this.openModal());
    }
    
    // Close modal
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.closeModal());
    });
    
    // Close on overlay click (clicking outside the content)
    this.addEventListener('click', (e) => {
      // 检查点击是否在内容区域之外
      const desktopContent = this.querySelector('.product-viewer__compare-content');
      const mobileInner = this.querySelector('.product-viewer__compare-mobile-inner');
      const navPrev = this.querySelector('.product-viewer__compare-nav--prev');
      const navNext = this.querySelector('.product-viewer__compare-nav--next');
      
      // 如果点击的不是内容区域、导航按钮，则关闭弹层
      const isClickOnContent = desktopContent && desktopContent.contains(e.target);
      const isClickOnMobileInner = mobileInner && mobileInner.contains(e.target);
      const isClickOnNavPrev = navPrev && navPrev.contains(e.target);
      const isClickOnNavNext = navNext && navNext.contains(e.target);
      
      if (!isClickOnContent && !isClickOnMobileInner && !isClickOnNavPrev && !isClickOnNavNext) {
        this.closeModal();
      }
    });
    
    // Desktop navigation
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.navigate('prev'));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.navigate('next'));
    }
    
    // Mobile navigation
    if (this.prevBtnMobile) {
      this.prevBtnMobile.addEventListener('click', () => this.navigate('prev'));
    }
    if (this.nextBtnMobile) {
      this.nextBtnMobile.addEventListener('click', () => this.navigate('next'));
    }
    
    // Indicator clicks
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!this.classList.contains('active')) return;
      
      if (e.key === 'Escape') {
        this.closeModal();
      } else if (e.key === 'ArrowLeft') {
        this.navigate('prev');
      } else if (e.key === 'ArrowRight') {
        this.navigate('next');
      }
    });
    
    // Touch swipe for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    const mobileInner = this.querySelector('.product-viewer__compare-mobile-inner');
    if (mobileInner) {
      mobileInner.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      mobileInner.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
    }
  }
  
  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.navigate('next');
      } else {
        this.navigate('prev');
      }
    }
  }
  
  openModal() {
    this.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.currentIndex = 0;
    this.updateSlides();
  }
  
  closeModal() {
    this.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  navigate(direction) {
    if (direction === 'prev') {
      // 循环到最后一个
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.totalSlides - 1;
    } else if (direction === 'next') {
      // 循环到第一个
      this.currentIndex = this.currentIndex < this.totalSlides - 1 ? this.currentIndex + 1 : 0;
    }
    this.updateSlides();
  }
  
  goToSlide(index) {
    if (index >= 0 && index < this.totalSlides) {
      this.currentIndex = index;
      this.updateSlides();
    }
  }
  
  updateSlides() {
    // Update desktop slides
    this.desktopSlides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentIndex);
    });
    
    // Update mobile slides
    this.mobileSlides.forEach((slide, index) => {
      slide.classList.toggle('active', index === this.currentIndex);
    });
    
    // Update indicators
    this.indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === this.currentIndex);
    });
    
    this.updateNavButtons();
  }
  
  updateNavButtons() {
    // 循环模式下，按钮始终可用
    // Desktop buttons
    if (this.prevBtn) {
      this.prevBtn.disabled = false;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = false;
    }
    
    // Mobile buttons
    if (this.prevBtnMobile) {
      this.prevBtnMobile.disabled = false;
    }
    if (this.nextBtnMobile) {
      this.nextBtnMobile.disabled = false;
    }
  }
}

customElements.define('product-viewer-compare', ProductViewerCompare);